var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtraordinaryRainbow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1128,
    height: 1020,
    viewBox: "0 0 1128 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_8504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2340.16 1177.08C2340.16 526.998 1813.16 7.98678e-05 1163.08 5.14518e-05C512.997 2.30358e-05 -14 526.997 -14.0001 1177.08C-14.0001 1827.16 512.997 2354.16 1163.08 2354.16C1813.16 2354.16 2340.16 1827.16 2340.16 1177.08Z",
    fill: "#0279B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255.92 1177.08C2255.92 573.525 1766.64 84.2431 1163.08 84.2431C559.526 84.2431 70.2441 573.525 70.2441 1177.08C70.2441 1780.64 559.526 2269.92 1163.08 2269.92C1766.64 2269.92 2255.92 1780.64 2255.92 1177.08Z",
    fill: "#02B07D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2171.67 1177.08C2171.67 620.05 1720.11 168.488 1163.08 168.488C606.053 168.488 154.49 620.05 154.49 1177.08C154.49 1734.11 606.052 2185.67 1163.08 2185.67C1720.11 2185.67 2171.67 1734.11 2171.67 1177.08Z",
    fill: "#E6A236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087.43 1177.08C2087.43 666.578 1673.58 252.731 1163.08 252.731C652.579 252.731 238.732 666.578 238.732 1177.08C238.732 1687.58 652.579 2101.43 1163.08 2101.43C1673.58 2101.43 2087.43 1687.58 2087.43 1177.08Z",
    fill: "#88D76C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2003.19 1177.08C2003.19 713.099 1627.06 336.972 1163.08 336.972C699.102 336.972 322.975 713.099 322.975 1177.08C322.975 1641.06 699.102 2017.19 1163.08 2017.19C1627.06 2017.19 2003.19 1641.06 2003.19 1177.08Z",
    fill: "#E65654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.95 1177.08C1918.95 759.627 1580.53 421.216 1163.08 421.216C745.628 421.216 407.217 759.627 407.217 1177.08C407.217 1594.53 745.628 1932.94 1163.08 1932.94C1580.53 1932.94 1918.95 1594.53 1918.95 1177.08Z",
    fill: "#A46FE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.7 1177.08C1834.7 806.154 1534.01 505.462 1163.08 505.462C792.155 505.462 491.463 806.154 491.463 1177.08C491.463 1548.01 792.155 1848.7 1163.08 1848.7C1534.01 1848.7 1834.7 1548.01 1834.7 1177.08Z",
    fill: "#D5A4C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.46 1177.08C1750.46 852.681 1487.48 589.704 1163.08 589.704C838.681 589.704 575.704 852.681 575.704 1177.08C575.704 1501.48 838.681 1764.46 1163.08 1764.46C1487.48 1764.46 1750.46 1501.48 1750.46 1177.08Z",
    fill: "#C42231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.21 1177.08C1666.21 899.208 1440.95 673.947 1163.08 673.947C885.208 673.947 659.947 899.208 659.947 1177.08C659.947 1454.95 885.208 1680.21 1163.08 1680.21C1440.95 1680.21 1666.21 1454.95 1666.21 1177.08Z",
    fill: "#FD864F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.97 1177.08C1581.97 945.733 1394.43 758.188 1163.08 758.188C931.735 758.188 744.19 945.733 744.19 1177.08C744.19 1408.43 931.735 1595.97 1163.08 1595.97C1394.43 1595.97 1581.97 1408.43 1581.97 1177.08Z",
    fill: "#2A5B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.73 1177.08C1497.73 992.26 1347.9 842.435 1163.08 842.435C978.261 842.435 828.436 992.26 828.436 1177.08C828.436 1361.9 978.261 1511.73 1163.08 1511.73C1347.9 1511.73 1497.73 1361.9 1497.73 1177.08Z",
    fill: "#43BFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.48 1177.08C1413.48 1038.79 1301.38 926.678 1163.08 926.678C1024.79 926.678 912.679 1038.79 912.679 1177.08C912.679 1315.37 1024.79 1427.48 1163.08 1427.48C1301.38 1427.48 1413.48 1315.37 1413.48 1177.08Z",
    fill: "#F4FF7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_8504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1128,
    height: 1020,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraordinaryRainbow);
export default __webpack_public_path__ + "static/media/extraordinary-rainbow.566cca30bc8f2c1a37cc9bf1ac1fa39c.svg";
export { ForwardRef as ReactComponent };